import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TimeOfDayLegend = ({ children }) => (_jsxs("div", { className: "d-flex flex-wrap row g-0 mt-4 mb-3", children: [_jsx("div", { className: "col-3 bg-danger border", style: {
                backgroundImage: "linear-gradient(to right, #FFF, transparent)",
                height: "1.25rem",
            } }), _jsx("div", { className: "col-12 col-lg-8 ms-lg-4", children: children })] }));
